module.exports = __webpack_public_path__ + "static/media/REWARDS@3x.e8586485.png";